import { Button, SelectInput } from 'components'
import React, { useRef, useState } from 'react'
import { useAlgoEditorSettings, useAlgoEditorState } from 'state'
import { useOnClickOutside } from 'usehooks-ts'

import { ChevronUpIcon, CogIcon } from '@heroicons/react/solid'

const AlgoEditorBottomBar = ({
  handleRunCode,
  handleSubmitCode,
  handleOnLanguageChangeValue
}: {
  handleRunCode: (_: boolean) => void
  handleSubmitCode: () => void
  saveCodeInLoacalStorage?: boolean
  handleOnLanguageChangeValue?: (_selected: string) => void
}) => {
  const [settings, updateSettings, setSettingsOpen] = useAlgoEditorSettings()
  const { languages: langState } = useAlgoEditorState()
  const btnRef = useRef<HTMLDivElement>(null)
  const [isCustomInputOpen, setIsCustomInputOpen] = useState(false)

  const handleClickOutside = () => setIsCustomInputOpen(false)

  useOnClickOutside(btnRef, handleClickOutside)

  return (
    <div className="flex flex-row gap-4 items-center justify-between py-3 px-4 border-t-1 border-zinc-800 z-10">
      <div className="flex flex-row items-center space-x-2">
        <Button
          variant="transparent"
          className="px-2"
          onClick={() => setSettingsOpen(true)}>
          <CogIcon className="h-6 w-6 m-auto" />
        </Button>

        <SelectInput
          position="above"
          text={settings.language.language_description}
          className="border border-zinc-600 rounded-lg w-max"
          options={langState.map((language) => ({
            label: language.language_description,
            id: language.id
          }))}
          selected={[settings.language.id]}
          onChangeValue={([selected]) => {
            const language = langState.find((option) => option.id === selected)
            if (language) {
              updateSettings({ language })
              handleOnLanguageChangeValue &&
                handleOnLanguageChangeValue(selected)
            }
          }}
        />
      </div>

      <div className="flex flex-row items-center space-x-2">
        <div ref={btnRef} className="relative">
          <Button className="bg-zinc-800 flex justify-between items-center text-base py-1.5 px-2 ">
            <div onClick={() => handleRunCode(false)}>Run Tests</div>
            <div className="pl-1">
              <ChevronUpIcon
                className="h-4 w-4 z-20"
                onClick={() => {
                  setIsCustomInputOpen(!isCustomInputOpen)
                }}
              />
            </div>
          </Button>
          {isCustomInputOpen && (
            <Button
              className="absolute bottom-16 bg-zinc-700 whitespace-nowrap text-base py-1.5 px-2 "
              onClick={() => {
                handleRunCode(true)
                setIsCustomInputOpen(false)
              }}>
              Run Custom Testcases
            </Button>
          )}
        </div>

        <Button
          className="text-base py-1.5 px-2"
          onClick={() => handleSubmitCode()}>
          Submit
        </Button>
      </div>
    </div>
  )
}

export default AlgoEditorBottomBar
